import React from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { Box, Button } from '@mui/material';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { getBlogPage } from '../../../api/page/blog.js';
import { getMenuItems } from '../../../api/menu/menu.js';
import { useOnRenderedContext } from '../../../context/OnRenderedContext.js';
import { HeaderWithMenu } from '../../../components/index.js';
import { faWeight } from '@fortawesome/free-solid-svg-icons';
import BlogBreadcrumb from '../../../components/blog/BlogBreadcrumb.js';
import BlogCategory from '../../../components/blog/BlogCategory.js';

const MAX_WIDTH = '1600px';
const path='guide/dizionario-mutui/';
const slug = 'dizionario-mutui';
const slugLabel = 'dizionario mutui';
const ogImage = '';
const metaTitle = 'Dizionario sui mutui, i termini e le parole più usate';
const metaDescription = `Una spiegazione semplice e veloce a tutte quelle parole strane e difficile che si incontrano nell'iter di presentazione di domanda di mutuo.`;
const categoryDescription = `Vuoi sottoscrivere un mutuo ma hai già letto tante parole "strane" di cui ignori il significato? Che cos'è una surroga, il loan to value o cosa si intende per caparra confirmatoria? All'interno di questa sezione trovi una spiegazione semplice e rapida che ti aiuterà a capire i termini più tecnici e complessi necessari per presentare una richiesta di mutuo in banca in maniera consapevole.`;
const mainTitle='DIZIONARIO SUI MUTUI';
const gradientStart = 'rgba(11,134,134,1)';
const gradientMiddle = 'rgba(11,134,134,0)';
const gradientEnd = 'rgba(11,134,134,0)';


const Category = (props) => {
    const { pages, total, menuItems } = props;
    const [, setOnRendered] = useOnRenderedContext();
  
    const { t } = useTranslation();

  setOnRendered(true, 'blog category');

  const router = useRouter();
  const p = router.asPath.slice(1);
  const canonicalURL = `https://www.tassomutuo.it/${p}`.split('?')[0];

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalURL} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={ogImage} />
      </Head>
      <style>{':root { --category-color: #0B8686}; body { overflow-x:unset};'}</style>
      <HeaderWithMenu menuItems={menuItems} />

      <Box
        className="blogCategoryContainer"
        sx={{
          padding: '80px 0px 0px 0px',
        }}>
        <Box
          className="blogCategoryHeading"
          sx={{
            backgroundImage: 'url(/books-tassi.svg)',
            backgroundColor: 'var(--category-color)',
            backgroundSize: 'cover',
            position: 'relatve',
            overflow: 'hidden',
          }}>
          <Box
            type="h1"
            display="flex"
            sx={{
              background: 'transparent',
              width: '100%',
              minHeight: '300px',
              color: '#fff',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'var(--font-red-hat-display)',
              fontWeight: 'bold',
              fontSize: '52px',
              background: `linear-gradient(0deg, ${gradientStart} 0%, ${gradientMiddle} 94%, ${gradientEnd} 100%)`,
              textShadow: '0px 4px 4px rgba(0,0,0,0.2);',
            }}>
            {mainTitle}
          </Box>
        </Box>
        {/* functionality separator */}
        <Box
          className="Blog"
          display="flex"
          sx={{
            maxWidth: MAX_WIDTH,
            margin: '0 auto',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: ' 60px 40px',
            '@media(max-width: 900px)': { padding: '60px 20px' },
          }}>
          <BlogBreadcrumb category={slug} label={slugLabel} />
          {/* <Box>search</Box> */}
        </Box>
        <Box
          type="p"
          sx={{
            maxWidth: MAX_WIDTH,
            margin: '0 auto',
            padding: ' 0px 40px 40px 40px',
            fontSize: '25px',
            '@media(max-width: 900px)': { padding: '0px 20px 40px 20px' },
          }}>
          {categoryDescription}
        </Box>
        <Box
          className="blogCategoryList"
          sx={{
            maxWidth: MAX_WIDTH,
            margin: '0 auto',
            padding: ' 0px 40px 40px 40px',
            '@media(max-width: 900px)': { padding: '0px 20px 40px 20px' },
          }}>
          <BlogCategory pages={pages} />
        </Box>
      </Box>
    </>
  );
};

export async function getServerSideProps({ query }) {
  try {
    const res = await getBlogPage(path, 0, 30);
    const menuItemsRes = await getMenuItems();
    const { data: menuItems } = menuItemsRes;
    const {data: {pages, total}} = res;

    return {
      props: {
        pages,
        total,
        menuItems,
      },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
}

export default Category;